import { z as zod, type ZodType } from 'zod';

/**
 * Creates a Zod schema for a base DTO (Data Transfer Object) with an `id` property.
 *
 * @template TId - The Zod type for the `id` property. Defaults to `zod.ZodNumber`.
 * @param idSchema - Optional custom Zod schema for the `id` property. If not provided, defaults to `zod.number()`.
 * @returns A Zod object schema with a single `id` property using the provided or default schema.
 */
export const createBaseDtoSchema = <TId extends ZodType = zod.ZodNumber>(idSchema?: TId) => {
  const resolvedIdSchema = idSchema ?? zod.number().optional();

  return zod.object({
    id: resolvedIdSchema,
  });
};
